import React, { useState, useEffect } from 'react';
// import styles from "./Files.scss";
import { IStep } from './NewPropertySteps';
import { IUploadFile } from '../FileUpload';
// import FileUpload from '../FileUpload';

const FileUpload = React.lazy(() => import(/* webpackChunkName: "fileUpload" */ '../FileUpload'));


export interface IFilesProps {
    step: IStep;
    data: Array<IUploadFile>;
    onChange: (fileList: Array<IUploadFile>) => Promise<void>;
}

const acceptedFileTypes = [
    'image/jpeg',
    'image/png',
    // 'application/pdf'
];

const Files: React.FC<React.PropsWithChildren<IFilesProps>> = ({ data = null, step = null, onChange = () => Promise.reject() }) => {
    // const handleChange = (fileList: File[]) => {
    //     return onChange(fileList);
    // };

    return (
        <div>
            <FileUpload files={data} name="files" accept={acceptedFileTypes} multiple onChange={onChange} />
        </div>
    );
};

export default Files;
